import React from 'react';
import {
    Heading,
    FormContainer,
    SubHeading,
    TermsAndConditionsWrapper,
    SmallText,
    SignUpLink,
    HoverLink,
} from '../style';
import { AuthenticationWrapper } from '../AuthenticationWrapper';
import { Row } from '../../../Layouts';

import { externalLinks, paths } from '../../../../Constants/paths';

export const SignInWrapper = ({ children }) => (
    <AuthenticationWrapper>
        <FormContainer>
            <Heading marginBottom={'12px'}>Sign in</Heading>
            <SubHeading marginBottom={'24px'}>Welcome back!</SubHeading>

            {children}

            <TermsAndConditionsWrapper>
                <HoverLink to={{ pathname: externalLinks.TERMS_AND_CONDITIONS }} target={'_blank'}>
                    Terms & Conditions
                </HoverLink>
                <Row marginTop={'8px'}>
                    <SmallText marginRight={'4px'}>View our</SmallText>
                    <HoverLink to={{ pathname: externalLinks.PRIVACY_POLICY }} target={'_blank'}>
                        privacy policy.
                    </HoverLink>
                </Row>
            </TermsAndConditionsWrapper>

            <Row>
                <SubHeading marginRight={'8px'}>Don't have an account?</SubHeading>
                <SignUpLink to={paths.SIGN_UP}>Sign up</SignUpLink>
            </Row>
        </FormContainer>
    </AuthenticationWrapper>
);



// WEBPACK FOOTER //
// ./src/UI/Containers/Authentication/SignIn/SignInWrapper.js